export default __webpack_public_path__ + "static/traffic-lead-5-4a995c46a53db661b938cc186de5d537.jpg";